export { default } from './GuideContentBody';
